import axios from 'axios'
import qs from 'qs'
import { getEnv } from 'aria-viewer/utils/environment'

const BASE_API_URL = getEnv('REACT_APP_BASE_API_URL')

const ajax = (method, url, data, config) => {
    return axios[method](url, data, config)
        .then(response => {
            const data = response.data
            if (data.error) {
                return Promise.reject(data.message)
            } else {
                return data.data ? data : { data }
            }
        })
        .catch(({ response }) => {
            try {
                return { error: response.data.message }
            } catch (e) {
                return { error: e.message }
            }
        })
}

const axiosAjax = {
    getApi: (url, data) => {
        return axiosAjax.get(`${BASE_API_URL}${url}`, data)
    },
    postApi: (url, data, config) => {
        return axiosAjax.post(`${BASE_API_URL}${url}`, data, config)
    },
    putApi: (url, data, config) => {
        return axiosAjax.put(`${BASE_API_URL}${url}`, data, config)
    },
    get: (url, data) => {
        return ajax('get', url, { params: data })
    },
    post: (url, data, config) => {
        return ajax('post', url, qs.stringify(data), config)
    },
    put: (url, data, config) => {
        return ajax('put', url, qs.stringify(data), config)
    },
}

export default axiosAjax
